<template>
    <div class="login-page">
        <div class="login-card">

            <img class="login-logo" src="admin/logo.png" alt="Logo"/>
            <h2 class="title">Login (Shore)</h2>
            <p v-if="errorAlert" class="error-message">Your information is not valid 😥</p>

            <form @submit.prevent="submitLogin">
                <input type="text" v-model="username" placeholder="Enter Username" class="input-field" autofocus required/>
                <input type="password" v-model="passWord" placeholder="Password" class="input-field" required/>
                <button type="submit" :disabled="loading" class="login-button">{{ loading ? "Please wait..." : "Log in" }}</button>
            </form>

        </div>
    </div>
</template>

<script>

    import auth from '@/auth'

    export default {
        name: 'Login',
        data() {
            return {
                logoLink: 'http://pms.maricruit.com/images/logo.png',
                username: '',
                passWord: '',
                errorAlert: false,
                loading: false,
            }
        },
        computed: {},
        mounted() {
            this.checkLoggedIn()
        },
        methods: {
            checkLoggedIn: async function () {
                const isLoggedIn = auth.loggedIn();
                if (isLoggedIn) {
                    return this.$router.push({path: '/'})
                }
            },
            submitLogin: async function () {
                this.loading = true;
                const userData = {
                    username: this.username,
                    password: this.passWord
                };
                this.$http.post('/api/user-login', userData).then(response => {
                    const loginData = response.data;
                    localStorage.setItem('adminLoginData', JSON.stringify(loginData));
                    localStorage.setItem('vessel_id', loginData.vessel_id);
                    localStorage.setItem('vessel_name', loginData.vessel_name);
                    localStorage.setItem('vessel_type_id', loginData.vessel_type);
                    this.loading = false;
                    window.location.reload();
                }).catch(error => {
                    console.log(error?.response);
                    this.loading = false;
                    this.errorAlert = true;
                });
            }
        }
    }
</script>

<style scoped>
    .login-page {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(135deg, #002f4b, #005f73);
        background-size: cover;
        padding: 20px;
    }

    .login-card {
        width: 350px;
        background: rgba(255, 255, 255, 0.08);
        padding: 30px;
        border-radius: 16px;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        text-align: center;
        color: #fff;
    }

    .login-logo {
        width: 120px;
        margin-bottom: 20px;
    }

    .title {
        margin-bottom: 15px;
        font-weight: 600;
        font-size: 24px;
    }

    .error-message {
        background: rgba(255, 0, 0, 0.2);
        color: #ffb3b3;
        padding: 8px;
        border-radius: 6px;
        margin-bottom: 15px;
    }

    .input-field {
        width: 100%;
        padding: 12px;
        margin: 10px 0;
        border-radius: 8px;
        border: none;
        outline: none;
        background: rgba(255, 255, 255, 0.2);
        color: #fff;
    }

    .input-field::placeholder {
        color: rgba(255, 255, 255, 0.7);
    }

    .login-button {
        width: 100%;
        padding: 12px;
        margin-top: 15px;
        background: #030148c2;
        border: none;
        border-radius: 8px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
    }

    .login-button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>

